import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsAuthorityApi,
  IAboutUsAuthorityApiRequest,
  IAboutUsAuthorityApiGetAllAttrs,
  IAboutUsAuthorityApiGetAllResponse,
  IAboutUsAuthorityApiGetAttrs,
  IAboutUsAuthorityApiGetResponse,
  IAboutUsAuthorityApiSaveAttrs,
  IAboutUsAuthorityApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/authority/about-us-authority-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsAuthorityApi extends BaseApi<IAboutUsAuthorityApi> implements IAboutUsAuthorityApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_AUTHORITY_URL
  private aboutUsAuthorityUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home banners
   *
   * @method POST
   * @url TBD
   * @access private (only user that logged in)
   *
   * @param {IAboutUsAuthorityApiGetAllAttrs} payload
   *
   * @return {Promise<IAboutUsAuthorityApiGetAllResponse>} Promise<IAboutUsAuthorityApiGetAllResponse>
   */
  async aboutUsAuthority_getAboutUsAuthorities(
    payload: IAboutUsAuthorityApiGetAllAttrs,
  ): Promise<IAboutUsAuthorityApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.aboutUsAuthorityUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @url TBD
   * @access private (only user that logged in)
   *
   * @param {IAboutUsAuthorityApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsAuthorityApiGetResponse>} Promise<IAboutUsAuthorityApiGetResponse>
   */
  async aboutUsAuthority_getAboutUsAuthority(payload: IAboutUsAuthorityApiGetAttrs): Promise<IAboutUsAuthorityApiGetResponse> {
    try {
      const response = await this.POST(`${this.aboutUsAuthorityUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @url TBD
   * @access private (only user that logged in)
   *
   * @param {IAboutUsAuthorityApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsAuthorityApiSaveResponse>} Promise<IAboutUsAuthorityApiSaveResponse>
   */
  async aboutUsAuthority_saveAboutUsAuthority(payload: IAboutUsAuthorityApiSaveAttrs): Promise<IAboutUsAuthorityApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id
          ? `${this.aboutUsAuthorityUrl}/update/${payload.params.id}`
          : `${this.aboutUsAuthorityUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
